const SLACK_WEBHOOK_URLS = {
  production: 'https://hooks.slack.com/services/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', 
  stage: 'https://hooks.slack.com/services/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' // stage contact form
};

export const useSendFormData = () => {
    const sendDataForm = async (data) => {
      const webhookUrl = SLACK_WEBHOOK_URLS[process.env.REACT_APP_BRAVEUP_STAGE === 'production' ? 'production' : 'stage'];
      
      await fetch(webhookUrl, {
         method: 'POST',
         mode: 'no-cors',
         headers: {
            "Content-Type": "application/json",
          },
         body: JSON.stringify({
            text:`Nombre: ${data.Name}
                Email: ${data.Email} 
                Cargo: ${data.Position}
                Colegio: ${data.School} 
                Telefono: ${data.Phone}
                Pais: ${data.Country}
                Funciones: ${data.Functions}
                Opciones: ${data.Options}
                `
            })
       })
       .then(() => console.log('Request successful'))
       .catch((error) => console.log('error', error))
    }
  return { 
    sendDataForm
  }
}